<template>
  <div class=" page-wrapper member-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="">
        <div class="claim-wrap">
          <div class="claim-contents">
            <div class="claim-title">
              <h1>Invoice Data - {{ invoiceList.member_info.cfname }} {{ invoiceList.member_info.clname }}</h1>

              <button class="clear-search" @click="clearData">
                Clear Search
              </button>
            </div>
            <invoice-filter :filters="filterQuery" @onSearch="filterData" />

            <div class="claim-btn-wrap"></div>

            <div class="claim-list-tbl mt-3 table-responsive">
              <div class="top-pagination">
                <pagination :rows.sync="invoiceList" :filters="filterQuery" />
              </div>

              <invoice-table
                :billingInvoice="invoiceList"
                :formatDate="formatDate"
                :statusClass="statusClass"
                @refundHandler="onClickRefund"
              />
              <pagination :rows.sync="invoiceList" :filters="filterQuery" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/resource/Api";
import InvoiceFilter from "./InvoiceFilter.vue";
import InvoiceTable from "./InvoiceTable.vue";
import Helper from "@/resource/Helper";

const filterData = {
  invoice_id: "",
  service_start_date: "",
  service_end_date: "",
};

export default {
  components: {
    InvoiceFilter,
    InvoiceTable,
  },
  data() {
    return {
      filterQuery: {
        ...filterData,
        member_id: atob(this.$route.params.userId),
        policy_id: atob(this.$route.params.policyId),
      },
      invoiceList: [],
      breadcrumbItems: [{ title: "Invoice List", active: true }],
    };
  },
  methods: {
    clearData() {
      this.filterQuery = { ...filterData };
      this.getData(this.filterQuery);
    },
    openModal(row, modalId) {
      this.row = row;
      this.$bvModal.show(modalId);
    },
    filterData(filters) {
      this.filterQuery = { ...filters };

      let formattedFilters = { ...filters };

      Object.keys(formattedFilters).forEach((key) => {
        if (
          formattedFilters[key] &&
          typeof formattedFilters[key] === "string"
        ) {
          const dateMatch = formattedFilters[key].match(
            /^(\d{4})-(\d{2})-(\d{2})$/
          );
          if (dateMatch) {
            formattedFilters[key] = `${dateMatch[1]}-${dateMatch[2]}`; // Send YYYY-MM
          }
        }
      });

      this.getData(formattedFilters);
    },
    async getData(filters = {}) {
      let memberId = atob(this.$route.params.userId);
      let policyId = atob(this.$route.params.policyId);
      let url = "v2/get-invoice-listing";

      if (!filters || typeof filters !== "object") {
        filters = {};
      }

      if (!filters.member_id) {
        filters.member_id = memberId;
      }
      if (!filters.policy_id) {
        filters.policy_id = policyId;
      }

      let filterUrl = Helper.objToUrlParams(filters);
      url += `?${filterUrl}`;

      let loader = this.$loading.show();
      try {
        const res = await Api.get(url);
        this.invoiceList = res.data;
      } finally {
        loader.hide();
      }
    },

    formatDate(date) {
      if (date) {
        const formattedDate = new Date(date);
        return formattedDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      }
      return "";
    },
    statusClass(status) {
      switch (status?.toLowerCase()) {
        case "unpaid":
          return "unpaid";
        case "paid":
          return "paid";
        case "partial":
          return "partial";
        case "late":
          return "late";
        case "void":
          return "void";
        case "term":
          return "term";
        default:
          return "pending";
      }
    },
    payNow(invoiceId) {
      this.paymentUrl = process.env.VUE_APP_PAYMENT_URL + "N" + invoiceId;
    },
    onClickRefund() {
      console.log("HEre");
    },
  },
  created() {
    this.getData();
  },
  provide() {
    return {
      getInvoiceData: this.getData,
    };
  },
};
</script>

<style src="@/assets/css/viewclients.css"></style>
<style>
@import "../../../assets/css/claim-list.css";

input[type="file"] {
  display: none;
}

.choose-file-btn {
  display: inline-block;
  padding: 24px 24px;
  background-color: #f1f0ef;
  color: rgb(39, 39, 39);
  border: none;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 12px;
}

.choose-file-btn:focus {
  outline: none;
}

.action-bg {
  cursor: pointer;
  margin-left: 5px;
}

.rep-body-content-wrap {
  padding: 32px;
  background-color: #f3f6f8;
  margin-left: 200px;
  max-width: calc(100% - 200px);
  transition: all ease-in-out 0.3s;
}

.claim-list-tbl tbody tr td:last-child {
  /* border-right: 1px solid #0000001a; */
  height: 100%;
  border: none;
}

.claim-list-tbl tbody tr {
  border-right: 1px solid #0000001a;
}
</style>
